<template>
    <div class="gs-affiliate-settings-tab gs-affiliate-settings-tab--general">
        <div class="gs-affiliate-settings-tab__head">
            <h2>{{ $t('frontend_affiliate_settings_general') }}</h2>
        </div>
        <div class="gs-affiliate-settings-tab__body gs-affiliate-settings-tab__body--narrow gs-affiliate-settings__stack">
            <gs-field :label="$t('frontend_username')">
                <text-input v-model="localForm.username" :validator="validator.form.username"
                    :attribute="$t('frontend_username')" value="form.username"
                    :placeholder="$t('frontend_affiliate_settings_username')"
                    @input="delayTouch(validator.form.username)" />
            </gs-field>
            <gs-field :label="`${$t('frontend_affiliate')} Id`">
                <div class="gs-affiliate-settings__well">{{ userId }}</div>
            </gs-field>
        </div>
        <footer class="gs-affiliate-settings-tab__footer">
            <gs-button v-if="isValid" variant="primary" size="md" @click="saveAffiliateSettings()">{{
                $t('frontend_save') }}</gs-button>
            <gs-button v-else disabled variant="primary" size="md">{{ $t('frontend_save') }}</gs-button>
        </footer>
    </div>
</template>
<script>
const touchMap = new WeakMap();

export default {
    props: {
        form: {
            required: true
        },
        userId: {
            required: true
        },
        validator: {
            required: true
        },
        saveAffiliateSettings: {
            required: true,
            type: Function

        }
    },
    data() {
        return {
            localForm: this.form
        }
    },

    watch: {
        localForm: {
            handler: function (val, oldVal) {
                this.$emit('update-form', val);
            },
            deep: true
        }
    },
    computed: {
        isValid() {
            return !this.validator.form.username.$invalid;
        }
    },
    methods: {
        delayTouch($v) {
            $v.$reset();
            if (touchMap.has($v)) {
                clearTimeout(touchMap.get($v));
            }
            touchMap.set($v, setTimeout($v.$touch, 1000));
        },
    }

}
</script>

